<template>
  <a-tree-select
    :placeholder="$t('publish.workCategory.placeholder')"
    style="width: 100%"
    v-model="selectedCate"
    :replaceFields="{children:'children', title:'name', key:'id', value: 'id' }"
    :tree-data="cateTree"
    tree-default-expand-all
  ></a-tree-select>
</template>

<script>
import { getTree as getCateTree } from "@/api/cate";

export default {
  model: {
    prop: "value", //指向props的參數名
    event: "change", //事件名稱
  },
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      selectedCate: undefined,
      cateTree: [],
    };
  },
  watch: {
    selectedCate(value) {
      this.$emit("change", value);
    },
  },
  created() {
    getCateTree().then((res) => {
      this.cateTree = res.data;
      this.selectedCate = this.value;
    });
  },
  methods: {},
};
</script>

<style lang="less" scoped>
</style>
